export default (params) => `
  <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:web="http://webservice/">
    <soapenv:Header/>
    <soapenv:Body>
      <web:getSourceCountries>
        <userId>${params.userId}</userId>
        <userKey>${params.userKey}</userKey>
      </web:getSourceCountries>
    </soapenv:Body>
  </soapenv:Envelope>
`
